import { useCallback } from 'react';

const validate = (cred, noExpiration) => {
  const errors = {};

  if (!cred?.issued_at) {
    errors.issued_at = 'Issued date is required';
  }
  if (!cred?.expired_at && !noExpiration) {
    errors.expired_at = 'Expiration date is required';
  }

  return errors;
};

const hasFieldChanged = (current, original, field) =>
  (current?.[field] ?? '') !== (original?.[field] ?? '');

export const useCredentialArtifact = () => {
  const getErrors = useCallback((current, original, noExpiration) => {
    const allErrors = validate(current, noExpiration);
    const visibleErrors = {};
    Object.entries(allErrors).forEach(([field, message]) => {
      if (hasFieldChanged(current, original, field)) {
        visibleErrors[field] = message;
      }
    });
    return visibleErrors;
  }, []);

  const validateAll = useCallback((credentials, noExpirations, getKey) => {
    const allErrors = {};

    credentials.forEach((cred) => {
      const key = getKey(cred);
      const noExpiration = key in noExpirations ? noExpirations[key] : !cred?.expired_at;
      const credErrors = validate(cred, noExpiration);
      if (Object.keys(credErrors).length > 0) {
        allErrors[key] = credErrors;
      }
    });

    return allErrors;
  }, []);

  return { getErrors, validateAll };
};
